module.exports = __webpack_public_path__ + "static/media/Николаева Н., Манакова Н. (ДУ).89152f84.pdf";